export default __webpack_public_path__ + "static/media/holiday-25.ea801511.png";